import React, { useState, useEffect } from 'react';
import './App.module.scss';
import BaseLayout from "./components/BaseLayout";
import { BrowserRouter } from "react-router-dom";
import Loader from "./components/Loader";
import useSecurity from "./hooks/useSecurity";
import ContactBot from "./components/ContactBot";

function App() {
  useSecurity();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100%',
        position: 'relative'
      }}
    >
      {loading ? (
        <Loader />
      ) : (
        <>
          <ContactBot />
          <BrowserRouter>
            <BaseLayout />
          </BrowserRouter>
        </>
      )}
    </div>
  );
}

export default App;